import _ from 'lodash';
import { createSelector } from 'reselect';
import { FIELD_GROUP_ALX_FIELDS } from '../../consts';
import columnAndRecordConfigsSelector from './dataTable/columnAndRecordConfigsFactory';

export const selectorPropertyDataTableAlxColumns = createSelector(
  [
    columnAndRecordConfigsSelector([
      'propertyColumnConfigsBasedOnState',
      FIELD_GROUP_ALX_FIELDS
    ]),
    columnAndRecordConfigsSelector('fieldGroupsNumericalValues')
  ],
  (alxColumnConfigsBasedOnState, fieldGroupsNumericalValues) => {
    const fieldGroupsStringValues = _.invert(fieldGroupsNumericalValues);
    const columns = [];

    _.map(alxColumnConfigsBasedOnState, alxColumnConfig => {
      const {
        column_label,
        field_group,
        field_name,
        has_filter,
        order_by,
        interactive,
        order,
        visible,
        width
      } = alxColumnConfig;

      if (!visible) {
        return;
      }

      columns.push({
        columnInteractive: interactive,
        columnHasFilter: has_filter,
        orderBy: order_by,
        columnLabel: column_label,
        columnVisible: visible,
        columnWidth: width,
        fieldGroup: fieldGroupsStringValues[field_group],
        fieldName: field_name,
        order: order
      });
    });

    return _.orderBy(columns, 'order');
  }
);

export default selectorPropertyDataTableAlxColumns;
